import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import kidLearn1Img from '../assets/webp/kid-learn-1.webp';

const SelfTestCard: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate('/trivia-quiz')}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate('/trivia-quiz');
      }}
      className="h-[100px] relative mt-4 flex cursor-pointer items-center gap-3 overflow-visible rounded-3xl bg-[#E8EDF5] px-4 py-[18px]"
    >
      <img
        src={kidLearn1Img}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute bottom-[-6px] left-[-2px] h-[141px] w-[109px] object-contain"
      />

      <div className="flex flex-1 items-center gap-3 pl-[110px]">
        <div style={{ fontSize: 20, fontWeight: 900, color: '#6B7280', flexShrink: 0 }}>‹</div>
        <div className="flex-1 text-right">
          <div className="text-xl font-bold leading-tight text-[#1A1A2E]">
            {t('self_test_title', 'בחן את עצמך')}
          </div>
          <div className="mt-1 text-[14px] font-bold leading-snug text-[#6B7280]">
            {t('self_test_subtitle', 'מה אתה באמת יודע על הפרשה שלך')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfTestCard;
